<script setup>
import { markSSOPending } from '@/utils/login'
import { EXTERNAL_URLS } from '@/utils/constants'

const handleSSOLogin = () => {
  markSSOPending()
  const baseUri = import.meta.env.DEV ? 'http://localhost:8082' : ''
  window.location.href = `${baseUri}/oauth2/authorization/cloudidp`
}


const accessGuide = () => {
  window.open(EXTERNAL_URLS.CFES_ACCESS_GUIDE, '_blank')
}
</script>

<template>
  <div class="container">
    <div class="welcome-message">
      <h1>Welcome to CFES Admin Tool System</h1>
    </div>
    <div class="login-box">
      <h2>Volkswagen SSO</h2>
      <img class="brand-logo" src="@/assets/logo/logo-volkswagen.svg" alt="Volkswagen Logo" />
      <p class="login-info">You could login through the active directory with your Volkswagen account.</p>
      <button @click="handleSSOLogin" class="login-button">CloudIDP SSO Login</button>
    </div>
    <div class="reference-box">
      <p class="link-text" @click="accessGuide">
        Apply for access to CFES admin tool
      </p>
    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100vw;
  background: radial-gradient(circle at 20% 20%, #e0ebff 0, transparent 30%),
    radial-gradient(circle at 80% 0%, #e6fffb 0, transparent 32%),
    #f4f7fb;
  padding: 24px 16px;
  box-sizing: border-box;
}

.welcome-message {
  margin-bottom: 28px;
  text-align: center;
}

.welcome-message h1 {
  color: #0f172a;
  font-size: 30px;
  font-weight: 700;
  margin: 0;
}

.login-box {
  text-align: center;
  background: #fff;
  padding: 44px 38px;
  border-radius: 14px;
  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.12);
  width: 420px;
  max-width: 100%;
  border: 1px solid #e2e8f0;
}

.brand-logo {
  width: 64px;
  height: 64px;
  margin: 14px 0 18px;
}

.reference-box {
  display: block;
  text-align: center;
  margin-top: 26px;
}

.link-text {
  color: #1e3a8a;
  font-size: 1.02rem;
  font-weight: 600;
  cursor: pointer;
  border-left: 6px solid #3b82f6;
  padding: 0.45rem 1rem;
  background-color: #e0ecff;
  display: inline-block;
  border-radius: 6px;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.link-text:hover {
  background-color: #d2e4ff;
  color: #1d4ed8;
}

h2 {
  color: #0f172a;
  margin-bottom: 12px;
  font-size: 24px;
  font-weight: 700;
}

.login-info {
  color: #475569;
  margin-bottom: 26px;
  font-size: 15px;
}

.login-button {
  background-color: #2563eb;
  color: white;
  padding: 12px 20px;
  font-size: 16px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.08s ease-in-out;
  width: 100%;
}

.login-button:hover {
  background-color: #1d4ed8;
}

.login-button:active {
  transform: translateY(1px);
}
</style>
